module.exports = "/images/fga_logo_white_smaller.png?98135de3a257e8a663ce83d1c683e406";